import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Avatar,
  Badge,
  Chip
} from '@mui/material';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import API_BASE_URL from '../config/api';

const Navbar = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [currentStreak, setCurrentStreak] = useState(0);

  useEffect(() => {
    if (user) {
      fetchStreak();
      
      // Listen for submission events to refresh streak
      const handleSubmission = () => {
        fetchStreak();
      };
      
      window.addEventListener('submissionCreated', handleSubmission);
      
      return () => {
        window.removeEventListener('submissionCreated', handleSubmission);
      };
    }
  }, [user]);

  const fetchStreak = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/submissions/user/stats`,
        { withCredentials: true }
      );
      const streak = response.data.currentStreak || 0;
      setCurrentStreak(typeof streak === 'number' ? streak : parseInt(streak) || 0);
    } catch (error) {
      console.error('Error fetching streak:', error);
      setCurrentStreak(0);
    }
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1, cursor: 'pointer' }}
          onClick={() => navigate('/')}
        >
          Elite Studying
        </Typography>
        {user ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Button color="inherit" onClick={() => navigate('/')}>
              Questions
            </Button>
            <Button color="inherit" onClick={() => navigate('/profile')}>
              Profile
            </Button>
            <Chip
              icon={
                <WhatshotIcon 
                  sx={{ 
                    color: currentStreak >= 1 ? '#ff4444' : '#9e9e9e',
                    '&.MuiSvgIcon-root': {
                      color: currentStreak >= 1 ? '#ff4444' : '#9e9e9e'
                    }
                  }} 
                />
              }
              label={currentStreak}
              size="small"
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                color: 'white',
                '& .MuiChip-label': {
                  fontWeight: 'bold'
                },
                '& .MuiChip-icon': {
                  color: currentStreak >= 1 ? '#ff4444' : '#9e9e9e'
                }
              }}
            />
            {user.picture && (
              <Avatar src={user.picture} alt={user.name} sx={{ width: 32, height: 32, cursor: 'pointer' }} onClick={() => navigate('/profile')} />
            )}
            <Typography variant="body2">{user.name}</Typography>
            <Button color="inherit" onClick={logout}>
              Logout
            </Button>
          </Box>
        ) : (
          <Button color="inherit" onClick={() => navigate('/login')}>
            Login
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;

